import { useCallback } from 'react';

const useResettableStateSetter = (setState, resetFn) =>
  useCallback(
    (nextValue) => {
      setState(nextValue);
      resetFn?.();
    },
    [setState, resetFn],
  );

export default useResettableStateSetter;
